import { ActionIcon, Menu } from '@mantine/core';
import { useClipboard } from '@mantine/hooks';
// components
import { IConversationsUserPersona } from '@newo/api/gateway';
import { EllipsisVertical } from 'lucide-react';
import ActorData from '@/modules/Personas/components/ActorData';
// utils
import { cn } from '@/utils';
import { formatDate } from '@/modules/DateTime/utils';
import useConversationStore from '@/pages/Conversations/Conversations.store.ts';
// icons
// utils
import { MENU_PORTAL } from '@/const';

interface ContextMenuProps {
    className?: string;
    persona: IConversationsUserPersona;
    onActorSelect: (connectors: string[]) => void;
}

const handleTriggerClick = (event: React.MouseEvent) => {
    event.stopPropagation();
};

const ContextMenu = ({
    className,
    persona,
    onActorSelect
}: ContextMenuProps) => {
    const clipboard = useClipboard({ timeout: 500 });
    const togglePersonaDetails = useConversationStore(
        (state) => state.togglePersonaDetails
    );

    const handleTimeCopy = () => {
        const time = formatDate(persona.last_act_time, 'hh:mm a');
        clipboard.copy(time);
    };

    const handlePersonaDetails = () => {
        togglePersonaDetails(persona);
    };

    return (
        <Menu
            portalProps={{
                target: `#${MENU_PORTAL}`
            }}
            position="right"
            shadow="md"
            width={200}
        >
            <Menu.Target>
                <ActionIcon
                    className={cn(className)}
                    color="dark"
                    variant="transparent"
                    onClick={handleTriggerClick}
                >
                    <EllipsisVertical />
                </ActionIcon>
            </Menu.Target>

            <Menu.Dropdown>
                <Menu.Item onClick={handlePersonaDetails}>
                    Show persona details
                </Menu.Item>
                <Menu.Item onClick={handleTimeCopy}>Copy time</Menu.Item>
                <Menu.Label>Actors</Menu.Label>
                {persona.actors.map((actor) => {
                    const handleClick = () => {
                        onActorSelect([
                            `${actor.integration_idn}/${actor.connector_idn}`
                        ]);
                    };
                    return (
                        <Menu.Item
                            className="[&>div]:w-full [&>div]:overflow-hidden"
                            key={actor.id}
                            onClick={handleClick}
                        >
                            <ActorData data={actor} />
                        </Menu.Item>
                    );
                })}
            </Menu.Dropdown>
        </Menu>
    );
};

export default ContextMenu;
